import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { langFromPath, localizePath, toEnglishPath, toFrenchPath } from "@/i18n/routes";
import { fr } from "@/i18n/fr";
import { en } from "@/i18n/en";

const LangContext = createContext(null);
const DICTS = { fr, en };

export const LANG_STORAGE_KEY = "mc-lang";

export const rememberLang = (lang) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    /* stockage indisponible : sans conséquence */
  }
};

// La langue est déterminée par l'URL (prioritaire). localStorage mémorise
// uniquement le dernier choix fait via le sélecteur.
export const LangProvider = ({ children }) => {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);

  const value = useMemo(
    () => ({
      lang,
      t: DICTS[lang],
      l: (frPath) => localizePath(frPath, lang),
      switchPath: lang === "en" ? toFrenchPath(pathname) : toEnglishPath(pathname),
      otherLang: lang === "en" ? "fr" : "en",
    }),
    [lang, pathname],
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
